import React from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDStack } from '@facet-wealth/design';
import NextUpReviewButtonPicker
  from './ActionsPicker/NextUpReviewButtonPicker';
import AlertPicker from './AlertPicker';

const FooterContentPicker = ({ resource }) => {
  const hasAlert = resource.attr('alert')?.resources().length() > 0;

  if (hasAlert) {
    const alert = resource.attr('alert').resources().head();
    return (
      <FDBox maxWidth={'900px'}>
        <FDStack spacing={2} justifyContent="center" wrap>
          <NextUpReviewButtonPicker resource={resource} buttonText={'Review Actions'} />
          <AlertPicker resource={alert} />
        </FDStack>
      </FDBox>
    );
  }

  return (
    <NextUpReviewButtonPicker resource={resource} buttonText={'Review Actions & Send'} />
  );
};

FooterContentPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default FooterContentPicker;
